import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { useDynamicRoutes } from '../hooks/useDynamicRoutes';

/**
 * Componente de carga mientras se resuelven las rutas dinámicas
 */
const RouteLoader = () => (
    <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '200px',
        color: '#666'
    }}>
        <div>Cargando ruta...</div>
    </div>
);

/**
 * Componente que renderiza todas las rutas dinámicas
 * Optimizado para rendimiento con Suspense y memoización
 */
const DynamicRoutesRenderer = React.memo(({ enableDebug = false }) => {
    const { dynamicRoutes, isLoading, hasRoutes } = useDynamicRoutes(enableDebug);
    
    // Si el menú aún no ha cargado, no renderizar nada
    if (isLoading) {
        return null;
    }
    
    // Si no hay rutas dinámicas, no renderizar nada
    if (!hasRoutes) {
        return null;
    }
    
    return (
        <Suspense fallback={<RouteLoader />}>
            {dynamicRoutes.map((routeConfig) => (
                <Route
                    key={routeConfig.key}
                    exact={routeConfig.exact}
                    path={routeConfig.path}
                    component={routeConfig.component}
                />
            ))}
        </Suspense>
    );
});

DynamicRoutesRenderer.displayName = 'DynamicRoutesRenderer';

export default DynamicRoutesRenderer;
